<deletemodal id="customer-tabs" [deleteModal]="clearPopup"></deletemodal>

<!-- PopUp for Adding and Updating Data -->
<modal #createJapanDataModal class="createJapanDataModal-header">
    <modal-header>
        <div *ngIf="!isUpdate" class="color-blue">{{'config-system.ADD NEW DATA' |translate}}</div>
        <div *ngIf="isUpdate" class="color-blue">{{'config-system.MANAGE TOTAL CC' |translate}}</div>
    </modal-header>
    <modal-content>
        <form *ngIf="loadJapanDataForm" [formGroup]="loadJapanDataForm" (ngSubmit)="onSubmit(loadJapanDataForm.valid)"
            style="margin-left: -15px;width: 104%;" class="col-xs-12  ticket-color-validation" novalidate>
            <div class=" form-horizontal">
                <div class="row">
                    <label for="operatingCountryId"
                        class="col-sm-3 col-form-label">{{'config-system.Operating Country' |translate |translateKey}}</label>
                    <div class="col-sm-6 floating-input">
                        <input tabindex="0" type="text" float-label class="form-control ng-valid"
                            [value]="defaultCountryValue" [readonly]="disableCountry"  formControlName="operatingCountryId"/>
                    </div>
                </div>
                <div class="row">
                    <label for="processingYear"
                        class="col-sm-3 col-form-label">{{'config-system.Processing Year' |translate}}</label>
                    <div class="col-sm-6 floating-input">
                        <select class="form-control form-control-sm d-inline"  [attr.disabled]="disabled ? true : null" [(ngModel)]="year"
                             formControlName='processingYear' id='autofocus-modal-element'>
                            <option value='' selected='true'>{{'ticketing-system.Select Processing Year' |translate}}
                            </option>
                            <option *ngFor="let years of yearDropDown" [value]="years"  >
                                {{ years }}
                            </option>
                        </select>
                        <div class="alert-msg" *ngIf="!loadJapanDataForm.controls['processingYear'].valid  && loadJapanDataForm.controls['processingYear'].hasError('required') && (loadJapanDataForm.controls['processingYear'].touched || isSubmitted)">
                            {{'validation-message.Required'|translate}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label for="processingMonth"
                        class="col-sm-3 col-form-label">{{'config-system.Processing Month' |translate}}</label>
                    <div class="col-sm-6 floating-input">
                        <select class="form-control" [(ngModel)]="month" 
                             formControlName='processingMonth' [attr.disabled]="disabled ? true : null">
                            <option value='' selected='true'>{{'ticketing-system.Select Processing Month' |translate}}
                            </option>
                            <option *ngFor="let month of monthsDropDown; index as i" [value]="i + 1" >
                                {{ month }}
                            </option>
                        </select>
                        <div class="alert-msg" *ngIf="!loadJapanDataForm.controls['processingMonth'].valid  && loadJapanDataForm.controls['processingMonth'].hasError('required') && (loadJapanDataForm.controls['processingMonth'].touched || isSubmitted)">
                            {{'validation-message.Required'|translate}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <label for="totalCC" class="col-sm-3 col-form-label">{{'config-system.Total CC' |translate}}</label>
                    <div class="col-sm-6 floating-input">
                        <input id="totalCC-focus" tabindex="0" type="number" class="form-control"
                            placeholder="{{'config-system.Total CC' |translate}}" formControlName="totalCC" [(ngModel)]="totalCCValue"
                            >
                            <div class="alert-msg" *ngIf="!loadJapanDataForm.controls['totalCC'].valid  && loadJapanDataForm.controls['totalCC'].hasError('required') && (loadJapanDataForm.controls['totalCC'].touched || isSubmitted)">
                                {{'validation-message.Required'|translate}}
                            </div>
                    </div>
                </div>
            </div>
            <div class="pull-right pad-r-8">
                <button *ngIf="!isUpdate" class="btn blue-button" tabindex="0" type="submit">
                    {{'config-system.ADD' |translate}}
                </button>
                <button *ngIf="isUpdate" class="btn blue-button" tabindex="0" type="submit">
                    {{'config-system.UPDATE' |translate}}
                </button>

                <button class="btn grey-button" tabindex="0" type="button" (click)="closePopUp()">
                    {{'config-system.CANCEL' |translate}}
                </button>
            </div>
        </form>
    </modal-content>
    <modal-footer> </modal-footer>
</modal>

<div class="template3">
    <div class="body" [class.center-75per-width]="!isFileUpload">
        <div class="my-3">
            <div class="col my-3 download-template__label">
                {{'ticketing-system. * Option for Admin to Manage Japan Data ' |translate | translateKey}}
            </div>
            <section class="data-content">
                <div class="clearfix text-right">
                    <div class="col-md-12 left-padding-0">
                        <div class="row">
                            <div class="col-md-4 floating-input floatLabelContainer">
                                <input tabindex="0" type="text" float-label class="form-control country-one"
                                    [value]="defaultCountryValue"
                                    placeholder="{{'ticketing-system.Operating Country' |translate}}"
                                    [readonly]="disableCountry" />
                            </div>
                            <div class="col-md-4 floating-input floatLabelContainer">
                                <select class="form-control form-control-sm d-inline" [(ngModel)]="year"
                                    [ngModelOptions]="{ standalone: true }">
                                    <option [value]="0" selected>{{'ticketing-system.Processing Year' |translate}}
                                    </option>
                                    <option *ngFor="let years of yearDropDown" [value]='years'>
                                        {{ years }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-4 floating-input floatLabelContainer">
                                <select class="form-control" [(ngModel)]="month"
                                    [ngModelOptions]="{ standalone: true }">
                                    <option [value]="0" selected>{{'ticketing-system.Processing Month' |translate}}
                                    </option>
                                    <option *ngFor="let month of monthsDropDown; index as i" [value]="i + 1" >
                                        {{ month }}
                                    </option>
                                </select>
                            </div>
                            <!-- <div class="col-md-3 floating-input floatLabelContainer">
                                <input type="number" float-label class="form-control" [(ngModel)]="totalCCValue"
                                    placeholder="{{'ticketing-system.Total CC' |translate}}"
                                    (keyup.enter)="onSearchJapanData()" />
                            </div>
                            <div class="col-md-3"></div> -->
                        </div>
                    </div>
                    <div class="col-md-12  no-padding">
                        <button id="search-button" class="btn blue-button" tabindex="0" type="button"
                            (click)="onSearchJapanData()">{{'config-system.Search' |translate}}</button>
                        <button class="btn grey-button" tabindex="0" type="button"
                            (click)="clearFields()">{{'config-system.Cancel' |translate}}</button>
                        <div class="clearfix text-left font14">
                            <a autofocus="" tabindex="0" id="processor-btn" (click)="openCreateJapanDataModal()">
                                <span class="glyphicon glyphicon-plus"></span>
                                &nbsp;&nbsp;{{'config-system.ADD NEW' |translate}}
                            </a>
                        </div>
                    </div>
                </div>
            </section>

            <div class=" clearfix">
                <table class="table table-hover table-striped custab" aria-describedby=''>
                    <thead>
                        <tr>
                            <th class="pointer" id='operatingCountry'>
                                {{'config-system.Operating Country' |translate}}
                            </th>
                            <th class="pointer" id='processingYear'>
                                {{'config-system.Processing Year' |translate}}
                            </th>
                            <th class="pointer" id='processingMonth' (click)="sort('processingMonth')">
                                {{'config-system.Processing Month' |translate}}&nbsp;
                                <i class="fa"
                                    [ngClass]="{'fa-sort': sortOption != 'processingMonth', 'fa-sort-asc': (sortOption == 'processingMonth' && !isDesc), 'fa-sort-desc': (sortOption == 'processingMonth' && isDesc) }"
                                    aria-hidden="true"> </i>
                            </th>
                            <th class="pointer" id='totalCC' (click)="sort('totalCC')">
                                {{'config-system.Total CC' |translate}}&nbsp;
                                <i class="fa"
                                    [ngClass]="{'fa-sort': sortOption != 'totalCC', 'fa-sort-asc': (sortOption == 'totalCC' && !isDesc), 'fa-sort-desc': (sortOption == 'totalCC' && isDesc) }"
                                    aria-hidden="true"> </i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let loadDataForJapan of loadSearchResult">
                            <td *ngIf="loadDataForJapan.country === 'JPN'">JAPAN</td>
                            <td *ngIf="loadDataForJapan.year">{{loadDataForJapan.year}}</td>
                            <td *ngIf="loadDataForJapan.month">{{loadDataForJapan.month}}</td>    
                            <td *ngIf="loadDataForJapan.totalCC">{{loadDataForJapan.totalCC}}
                                <span class="pull-right header-font">
                                    <i id="edit" tabindex="0" type="button" class="fa fa-pencil color-blue"
                                        aria-hidden="true" (click)="editJapanData(loadDataForJapan.year,loadDataForJapan.month)"></i>
                                </span></td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="!loadSearchResult || loadSearchResult.length === 0" class="no-record-text">
                        <tr>
                            <td colspan='4'>{{'store-user.No records found' |translate}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/configuration/upload-japan-country-data.component.html